
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/stream-ultra-home-solar-system",
      function () {
        return require("private-next-pages/stream-ultra-home-solar-system/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/stream-ultra-home-solar-system"])
      });
    }
  